import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import chunk from 'lodash.chunk';
import VideoListItem from './VideoListItem';
import styles from './video-project.module.scss';

const VideoProject = ({project}) => {
  const {name, media} = project;
  const chunks = chunk(media, 3);

  return (
    <section className={styles.VideoProject}>
      <h1
        className={classNames(
          'has-text-weight-bold',
          styles.VideoProject__heading
        )}
      >
        {name}
      </h1>
      {chunks.map((videos, i) => (
        <div className="columns" key={`video-group-${i}`}>
          {videos.map((video, j) => (
            <div
              className={classNames(
                'column is-one-third box',
                styles.VideoProject__video
              )}
              key={`${video.id}-${i}-${j}`}
            >
              <VideoListItem isGridItem={true} useEmbed={true} video={video} />
            </div>
          ))}
        </div>
      ))}
    </section>
  );
};

VideoProject.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    media: PropTypes.arrayOf(
      PropTypes.shape({
        thumbnail: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }).isRequired,
        duration: PropTypes.number.isRequired,
        hashed_id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
};

export default VideoProject;



// WEBPACK FOOTER //
// ./src/components/videos/VideoProject.js